import { ColorService, darkTheme } from '@tableau/vizportalclient-common-components';
import { createTypeStyle } from 'typestyle';

import { SessionUserSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { getAppStore } from '~src/bootstrap/redux/store/AppStore';
import { FeatureFlags } from '~src/commonInfra/featureFlags/FeatureFlags';
import { Location } from '~src/commonInfra/utils/Location';
import { getSessionManagementServiceInstance } from '~src/sessionManagement/SessionManagementService';
import { sendUsageEvent } from '~src/spacesPlatform/hooks/useUsage';

import { supportedThemeSVGs } from './ThemeSupportedSVGList';

const darkModeImageUrlOverrideStyleElement = document.createElement('style');
darkModeImageUrlOverrideStyleElement.id = 'DarkModeImageUrlOverrideStyle';
document.head.appendChild(darkModeImageUrlOverrideStyleElement);

export function bootStrapTheme() {
    const sessionManagementService = getSessionManagementServiceInstance();
    sessionManagementService.bootstrapSessionPromise.then(() => {
        if (FeatureFlags.viewerControlledThemes_ViewingModeEnabled) {
            initializeTheme();
            if (Location.instance.search().indexOf('blackout') !== -1) {
                document.getElementsByTagName('html')[0].classList.add('black-out');
            }
            const result = SessionUserSelectors.viewerControlledTheme(getAppStore().getState());
            sendUsageEvent('ViewerControlledThemes', 'impression', {
                a: result
            });
            if (result === 'DARK') {
                ColorService.instance.setTheme('tds-dark');
            } else {
                ColorService.instance.setTheme('tds-light');
            }
        }
    });
}

function initializeTheme() {
    const stylesheets = document.styleSheets;
    for (let i = 0; i < stylesheets.length; i++) {
        const stylesheet = stylesheets[i];
        for (let j = 0; j < stylesheet.cssRules.length; j++) {
            const cssStyleRule = stylesheet.cssRules[j] as CSSStyleRule;
            try {
                if (cssStyleRule.style && cssStyleRule.style.backgroundImage && cssStyleRule.style.backgroundImage.indexOf('url("img/') !== -1) {
                    const imageWithoutPrefix = cssStyleRule.style.backgroundImage.replace('url("img/', '');
                    const imageFilenameOnly = imageWithoutPrefix.substring(0, imageWithoutPrefix.indexOf('?'));
                    if (supportedThemeSVGs[imageFilenameOnly]) {
                        cssStyleRule.selectorText.split(',').forEach(selector => {
                            const instance = createTypeStyle();
                            instance.cssRule(':root.' + darkTheme + ' ' + selector.trim(), {
                                backgroundImage: (ColorService.instance.globalContainer.cdnImageMap[cssStyleRule.style.backgroundImage] || cssStyleRule.style.backgroundImage).replace(/\.svg/g, '_tds-dark.svg')
                            });
                            const cssText = instance.getStyles();
                            darkModeImageUrlOverrideStyleElement.innerHTML += cssText;
                        });
                    }
                }
            } catch (e) {
                // for any case if the CSS manipulation fails, igonre the failure to avoid breaking the whole page.
            }
        }
    }
}